module.exports = __webpack_public_path__ + "img/lessonpbg.abd828eb.png";